import _padStart from "lodash/padStart";

function padStart() {
  return function (string = "", length = 0, chars = " ") {
    return _padStart(string, length, chars);
  };
}

export default padStart;
